export const admin = {
  title: "Administration",
  subtitle: "Manage users, categories and system settings",
  users: "Users",
  categories: "Categories",
  broadcast: "Broadcast",
  messages: "Messages",
  tickets: "Tickets",
  settings: "Settings",
  system: "System",
  languages: "Languages",
  totalUsers: "Total Users",
  totalCategories: "Total Categories",
  pendingSuggestions: "Pending Suggestions",
  userManagement: "User Management",
  userManagementDescription: "Manage user accounts and permissions",
  userManagementSelfHiddenHint: "Your own account is hidden in this list.",
  categoryManagement: "Category Management",
  broadcastManagement: "Broadcast Management",
  languageManagement: "Language Management",
  languageManagementDescription: "Manage translations for German and English",
  errorPagesTest: "Error Pages Test",
  errorPagesTestDescription: "Test the different error pages of the application",
  actionLog: "Action Log & Undo",
  actionLogDescription: "Recent administrative actions (can be undone)",
  systemStatus: "System Status",
  systemStatusDescription: "Monitor the current system state",
  username: "Username",
  email: "Email",
  role: "Role",
  status: "Status",
  actions: "Actions",
  active: "Active",
  suspended: "Suspended",
  admin: "Administrator",
  user: "User",
  joined: "Joined",
  scheduleBroadcast: "Schedule Broadcast",
  broadcastSubject: "Subject",
  broadcastMessage: "Message",
  broadcastType: "Type",
  broadcastTypeInfo: "Information",
  broadcastTypeWarning: "Warning",
  broadcastTypeAlert: "Alert",
  startDate: "Start Date",
  startTime: "Start Time",
  endDate: "End Date",
  endTime: "End Time",
  fillAllFields: "Please fill in all fields",
  endAfterStart: "End time must be after start time",
  broadcastScheduled: "Broadcast banner scheduled successfully",
  broadcastDescription: "Will be displayed from {start} to {end}",
  addLanguage: "Add Language",
  newLanguage: "Add New Language",
  newLanguageDescription: "Add a new language to the system. German translations will be copied as a template.",
  languageCode: "Language Code (e.g. fr, es, it)",
  languageName: "Language Name",
  languageFlag: "Country Flag",
  selectFlag: "Select Flag",
  availableLanguages: "Available Languages",
  chooseLanguage: "Choose a language to edit",
  editTranslation: "Edit Translation",
  key: "Key",
  value: "Value",
  translations: "Translations",
  clickToEdit: "Click on a translation to edit it",
  searchTranslations: "Search translation keys",
  searchTranslationsPlaceholder: "Filter by key...",
  translationColumnGerman: "German",
  translationColumnKey: "Key",
  translationColumnEnglish: "English",
  translationMissing: "Missing",
  translationAddValue: "Add",
  translationEditValue: "Edit",
  categoryNameGerman: "Category Name (German)",
  categoryNameEnglish: "Category Name (English)",
  parentCategory: "Parent Category",
  selectParent: "Select a parent category",
  noParent: "None (Main Category)",
  addCategory: "Add Category",
  editCategory: "Edit Category",
  germanNameRequired: "German name is required",
  categoryCreated: "Category created successfully",
  categoryUpdated: "Category updated successfully",
  categoryDeleted: '"{name}" has been deleted',
  deleteCategory: "Delete category?",
  deleteCategoryDescription: "This action cannot be undone.",
  topLevelCategories: "Top Level Categories",
  allCategories: "All Categories",
  inviteUser: "Invite User",
  inviteUserDescription: "Send an invite email linking to registration.",
  inviteEmail: "Email address",
  inviteEmailPlaceholder: "name@example.com",
  inviteEnglishLabel: "Send invite in English",
  inviteEmailRequired: "Email address is required",
  sendInvite: "Send invite",
  inviteSent: "Invite email sent",
  searchUsers: "Search users...",
  allUsers: "All Users",
  admins: "Administrators",
  suspendedUsers: "Suspended",
  deleteUser: "Delete user?",
  deleteUserDescription: "Do you really want to delete this user? This action cannot be undone.",
  userDeleted: "User has been deleted",
  userSuspended: "User has been suspended",
  userUnblocked: "User has been unblocked",
  userMadeAdmin: "is now an administrator",
  userUpdated: "User has been updated",
  editUserTitle: "Edit user",
  newCategory: "New Category",
  addSubcategory: "Add Subcategory",
  parentCategoryColumn: "Parent",
  websitesColumn: "Websites",
  subcategoriesColumn: "Subcategories",
  none: "-",
  deleteCategoryConfirm: "Do you really want to delete this category? All subcategories will also be deleted.",
  broadcastToAllUsers: "Send message to all users",
  broadcastToAllUsersDescription: "Send important notifications to all registered users",
  subjectRequired: "Subject *",
  subjectPlaceholder: "e.g. System Maintenance",
  messageRequired: "Message *",
  messagePlaceholder: "Message text...",
  bannerTypeRequired: "Banner Type *",
  bannerTypeInfo: "Information (Blue)",
  bannerTypeWarning: "Warning (Yellow)",
  bannerTypeAlert: "Important (Red)",
  startDateRequired: "Start Date *",
  startTimeRequired: "Start Time *",
  endDateRequired: "End Date *",
  endTimeRequired: "End Time *",
  bannerDisplayInfo: "The banner will be displayed at the top of the website during the specified period (directly below the header).",
  allVisitorsWillSee: "All visitors will see the banner during the active period.",
  scheduleBanner: "Schedule Banner",
  reset: "Reset",
  scheduledBanners: "Scheduled & Active Banners",
  scheduledBannersDescription: "Overview of all broadcast banners",
  scheduled: "Scheduled",
  completed: "Completed",
  administrators: "Administrators",
  openSuggestions: "Open Suggestions",
  manageLanguages: "Manage Languages",
  manageLanguagesDescription: "Manage languages and translations",
  categoryManagementTitle: "Category Management",
  categoryManagementFullDescription: "Create and manage categories",
  categoryTreeExpandNode: "Expand category branch",
  categoryTreeCollapseNode: "Collapse category branch",
  categoryDepthLimitHint:
    "Maximum category depth: {max} segments (root to leaf).",
  categoryDepthLimitReached:
    "Maximum category depth reached ({max} segments).",
  moveCategoryTitle: "Move websites",
  moveCategoryDescription:
    "Move all websites from \"{name}\" to another category.",
  moveCategoryConfirm: "Move",
  moveCategorySuccess: "{count} websites moved",
  moveCategoryTargetRequired: "Please select a target category.",
  tableUser: "User",
  tableRole: "Role",
  tableStatus: "Status",
  tableWebsites: "Websites",
  tableJoined: "Joined",
  tableLogin: "Login",
  tableActions: "Actions",
  tableCategory: "Category",
  tableParent: "Parent",
  tableSubcategories: "Subcategories",
  legalPages: "Legal Pages",
  legalPagesDescription: "Edit legal notice, privacy policy and terms of service",
  legalNotice: "Legal Notice",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  systemSettings: "System Settings",
  systemSettingsDescription: "General system configuration",
  systemSettingsEmpty: "No system settings available.",
  systemSettingsUnsupportedType: "This setting type is not supported yet.",
  systemSettingsItems: {
    emailVerificationEnabled: {
      label: "Email verification required",
      description:
        "When enabled, updated emails stay unverified until confirmation.",
      warning:
        "Email sending is limited to Gmail and has strict quotas. Do not overuse email dispatch; excessive sending may be blocked.",
    },
    aiCategorySuggestionEnabled: {
      label: "AI category suggestions",
      description:
        "Show AI-assisted category suggestions on the public website suggestion form.",
    },
    mlSmartSearchEnabled: {
      label: "AI home smart search",
      description:
        "Enables intelligent Home search that resolves text, category, and region filters automatically.",
    },
    searchEngineMode: {
      label: "Search engine mode",
      description:
        "Select whether website search uses PostgreSQL, shadow-probes OpenSearch, or reads from OpenSearch.",
      warning:
        "Switching to SHADOW or OPENSEARCH requires an active OpenSearch index.",
    },
    maintenanceModeEnabled: {
      label: "Maintenance mode",
      description:
        "Block non-admin access and show the maintenance notice on public pages.",
    },
    addressAutocompleteEnabled: {
      label: "Address autocomplete",
      description:
        "Enable Photon-powered address suggestions on website suggestion and add forms.",
    },
    ticketRetentionMonths: {
      label: "Ticket retention (months)",
      description:
        "Closed tickets older than this value are deleted by the scheduled cleanup job.",
      warning:
        "Allowed range: 1 to 60 months. Default is 12 months.",
    },
    ticketForwardingEmail: {
      label: "Ticket forwarding email",
      description:
        "Optional email inbox that receives forwarded ticket updates (links only).",
      warning:
        "Leave empty to disable forwarding. Attachments are never sent by email.",
    },
    "webkurator.categories.catalog.hash": {
      label: "Category catalog hash (read-only)",
      description:
        "Internal integrity value for startup category sync. This value is written automatically by the backend.",
      warning:
        "Do not edit this value manually. Apply catalog changes via Git updates to backend/src/main/resources/data/newCategories.json, then deploy/restart.",
    },
  },
  newRegistrations: "New Registrations",
  newRegistrationsDescription: "Allow new user registrations",
  websiteSuggestionsToggle: "Website Suggestions",
  websiteSuggestionsDescription: "Anonymous users can suggest websites",
  mlCategorization: "ML Categorization",
  mlCategorizationDescription: "Automatic category suggestions",
  enabled: "Enabled",
  disabled: "Disabled",
  searchEngineModeApplied: "Search mode updated.",
  searchEngineModeRebuildStarted:
    "OpenSearch indexing started. Search mode will switch automatically after it finishes.",
  searchEngineModePending:
    "OpenSearch indexing is running. Search mode changes are temporarily locked.",
  searchEngineModeConfirmTitle: "Build OpenSearch index first?",
  searchEngineModeConfirmDescription:
    "No active OpenSearch index exists yet. Building it may take a while because all active websites are indexed and aliases are switched after completion. The selected search mode will be applied automatically when the rebuild succeeds.",
  searchEngineModeConfirmAction: "Build index and switch",
  languageManagementTitle: "Language Management",
  languageManagementFullDescription: "Manage translations and add new languages",
  manageLanguagesButton: "Manage Languages",
  errorPagesTests: "Error Pages Tests",
  errorPagesFullDescription: "Test the different error pages of the application",
  error404: "404 - Page Not Found",
  error403: "403 - Access Denied",
  error500: "500 - Server Error",
  errorMaintenance: "Maintenance Mode",
  systemPanelFallbackItem: "Item",
  systemPanelFallbackSuggestion: "New website",
  actionLogTitle: "Action Log & Undo",
  actionLogFullDescription: "Recent administrative actions (can be undone)",
  categoryDeletedAction: 'Category "{name}" deleted',
  userSuspendedAction: 'User "{name}" suspended',
  websiteDeletedAction: 'Website "{name}" deleted',
  agoMinutes: "{count} minutes ago",
  ago5Minutes: "5 minutes ago",
  ago15Minutes: "15 minutes ago",
  agoHour: "1 hour ago",
  agoHours: "{count} hours ago",
  noMoreActions: "No more actions available",
  noMoreActionsDescription: "Actions older than 24 hours cannot be undone",
  systemStatusTitle: "System Status",
  systemStatusFullDescription: "Monitor the current system state",
  databaseConnection: "Database Connection",
  apiStatus: "API Status",
  backupSystem: "Backup System",
  lastBackup: "Last Backup",
  statusActive: "Active",
  statusOnline: "Online",
  statusFunctional: "Functional",
  statusChecking: "Checking...",
  statusUnavailable: "Unavailable",
  start: "Start",
  end: "End",
  allUsersFilter: "All Users",
  adminsFilter: "Administrators",
  usersFilter: "Users",
  suspendedFilter: "Suspended",
  deleteUserConfirmTitle: "Delete user?",
  deleteUserConfirmDescription: "Do you really want to delete user {username}? This action cannot be undone.",
  deleteCategoryConfirmTitle: "Delete category?",
  categoryNameExists: "Category name already exists.",
  deleteCategoryFullDescription: "Do you really want to delete category {name}? All {count} subcategories will also be deleted.",
  broadcastSendToAll: "Send message to all users",
  broadcastSendDescription: "Send important notifications to all registered users",
  userMessagesTitle: "User Messages",
  userMessagesDescription: "Send direct messages to individual users.",
  ticketInboxDescription:
    "Manage user bug reports and feature requests with threaded replies.",
  ticketStorageSummaryTitle: "Ticket Storage",
  ticketStorageSummaryDescription:
    "Attachment and message storage usage for the ticket inbox.",
  ticketStorageTotal: "Total ticket storage",
  ticketAttachmentTotal: "Total attachment storage",
  ticketTotalItems: "Tickets / Messages / Attachments",
  ticketTopStorage: "Top tickets by attachment size",
  ticketDeleteClosed: "Delete closed ticket",
  userMessagesRecipient: "Recipient",
  userMessagesRecipientPlaceholder: "Select a user",
  userMessagesSubject: "Subject",
  userMessagesSubjectPlaceholder: "e.g. Update on your suggestion",
  userMessagesBody: "Message",
  userMessagesBodyPlaceholder: "Write your message...",
  userMessagesSend: "Send message",
  userMessageSent: "Message sent successfully",
  scheduledActiveBanners: "Scheduled & Active Banners",
  bannersOverview: "Overview of all broadcast banners",
  emailVerificationTitle: "Email Verification",
  emailVerificationDescription:
    "Require users to confirm their email address after changes.",
  emailVerificationToggle: "Email verification required",
  emailVerificationToggleDescription:
    "When enabled, updated emails stay unverified until confirmation.",
  emailVerificationWarning:
    "Email sending is limited to Gmail and has strict quotas. Do not overuse email dispatch; excessive sending may be blocked.",
  useractivityFetchingFailed:
  "An error occured trying to fetch the user activity list",
  undoFailed: "An error occured during undoing the action",
  undoSuccess: "Undo successful",
  systemRebuildTitle: "Statistics Counter Rebuild",
  systemRebuildDescription:
    "Recalculate all persistent counters from current database data.",
  systemRebuildStatus: "Rebuild status",
  systemRebuildIdle: "Idle",
  systemRebuildRunning: "Running",
  systemRebuildCompleted: "Completed",
  systemRebuildFailed: "Failed",
  systemRebuildNoRunYet: "No rebuild job has been started yet.",
  systemRebuildStart: "Start rebuild",
  systemRebuildRefresh: "Refresh status",
  systemRebuildStarted: "Statistics rebuild started",
  systemRebuildStartFailed: "Failed to start statistics rebuild",
  systemRebuildLoadFailed: "Failed to load rebuild status",
  systemRebuildConfirmTitle: "Start statistics counter rebuild?",
  systemRebuildConfirmDescription:
    "This will recalculate all persistent statistics counters from current database data (regions, categories, depth counters, region-category counters, global totals, and monthly totals). On larger datasets this can take a long time and add database load. Usually this is only needed when counters are inconsistent after imports, incidents, or failed updates.",
  systemRebuildConfirmAction: "Start rebuild now",
  searchIndexRebuildTitle: "OpenSearch Index Rebuild",
  searchIndexRebuildDescription:
    "Rebuild the ACTIVE-only OpenSearch read model from PostgreSQL source data.",
  searchIndexRebuildStatus: "Rebuild status",
  searchIndexRebuildIdle: "Idle",
  searchIndexRebuildRunning: "Running",
  searchIndexRebuildCompleted: "Completed",
  searchIndexRebuildFailed: "Failed",
  searchIndexRebuildNoRunYet: "No OpenSearch rebuild has been started yet.",
  searchIndexRebuildRunningHint:
    "Rebuild is running in the backend. The read alias switches when rebuild completes.",
  searchIndexRebuildLastFinishedAt: "Last rebuild finished at",
  searchIndexRebuildStart: "Start OpenSearch rebuild",
  searchIndexRebuildRefresh: "Refresh OpenSearch status",
  searchIndexRebuildStarted: "OpenSearch rebuild started",
  searchIndexRebuildStartFailed: "Failed to start OpenSearch rebuild",
  searchIndexRebuildLoadFailed: "Failed to load OpenSearch status",
  searchIndexRebuildConfirmTitle: "Start OpenSearch rebuild?",
  searchIndexRebuildConfirmDescription:
    "This creates a new OpenSearch index and reindexes all ACTIVE websites before alias switch. On large datasets this can run for a long time and increase database and search cluster load.",
  searchIndexRebuildConfirmAction: "Start OpenSearch rebuild now",
  searchIndexEngineMode: "Search engine mode",
  searchIndexDocsOnReadAlias: "Docs on read alias",
  searchIndexOutboxPending: "Outbox pending",
  searchIndexOutboxFailed: "Outbox failed",
  instanceMigrationTitle: "Instance Migration",
  instanceMigrationDescription:
    "Temporarily pull data from the Docker instance into this Kubernetes instance with resumable checkpoints.",
  instanceMigrationDisabled:
    "The temporary migration feature is disabled in backend configuration.",
  instanceMigrationSourceUrl: "Source instance",
  instanceMigrationPageSize: "Page size",
  instanceMigrationStatus: "Migration status",
  instanceMigrationIdle: "Idle",
  instanceMigrationQueued: "Queued",
  instanceMigrationRunning: "Running",
  instanceMigrationPaused: "Paused",
  instanceMigrationCompleted: "Completed",
  instanceMigrationFailed: "Failed",
  instanceMigrationCurrentPhase: "Current phase",
  instanceMigrationCurrentDataset: "Current dataset",
  instanceMigrationProcessed: "Processed",
  instanceMigrationElapsed: "Elapsed",
  instanceMigrationEta: "ETA",
  instanceMigrationLastCheckpoint: "Last checkpoint",
  instanceMigrationSharedToken: "Shared token override",
  instanceMigrationSourceAdminEmail: "Source admin email override",
  instanceMigrationSourceAdminPassword: "Source admin password override",
  instanceMigrationRequestTimeoutMs: "Request timeout (ms)",
  instanceMigrationOptionalOverride: "Leave empty to keep stored/default value",
  instanceMigrationOverrideHint:
    "You can enter the source token and admin credentials here to start or resume a job without storing them in Kubernetes secrets.",
  instanceMigrationNoRunYet: "No instance migration job has been started yet.",
  instanceMigrationStart: "Start migration",
  instanceMigrationResume: "Resume migration",
  instanceMigrationRefresh: "Refresh status",
  instanceMigrationStarted: "Instance migration started",
  instanceMigrationStartFailed: "Failed to start instance migration",
  instanceMigrationLoadFailed: "Failed to load instance migration status",
  instanceMigrationConfirmTitle: "Start instance migration?",
  instanceMigrationConfirmDescription:
    "This temporarily imports website data from the configured source instance in resumable batches. Source users are only mapped to local accounts or the anonymous system user; legacy messages, tickets, broadcasts, and other history are skipped for speed.",
  instanceMigrationConfirmAction: "Start migration now",
  instanceMigrationDatasetProgress: "Dataset progress",
  instanceMigrationCounts: "Inserted / Updated / Skipped / Failed",
  instanceMigrationEmptyDatasets: "No dataset progress available yet.",
  instanceMigrationStorageTitle: "Migration storage",
  instanceMigrationStorageDatabase: "Database size",
  instanceMigrationStorageMeasured: "Migration size now",
  instanceMigrationStorageProjected: "Projected final migration size",
  instanceMigrationStorageQuota: "Approved quota assumption",
  instanceMigrationStorageAdditional: "Estimated remaining growth",
  instanceMigrationStorageHeadroom: "Estimated import headroom",
  instanceMigrationStorageRows: "Rows",
  instanceMigrationStorageCurrent: "Current",
  instanceMigrationStorageProjectedShort: "Projected",
  instanceMigrationStorageAdditionalShort: "Additional",
  instanceMigrationStorageTableIndexes: "Table / indexes",
  instanceMigrationStorageQuotaHint:
    "Measured from PostgreSQL. The 200Gi value is the approved quota assumption, not live Kubernetes PVC free space.",
  instanceMigrationStorageResumeWarning: "Storage warning:",
  instanceMigrationStorageOk: "OK",
  instanceMigrationStorageWarning: "Warning",
  instanceMigrationStorageCritical: "Critical",
  instanceMigrationStorageUnknown: "Unknown",
  systemLogsTitle: "Backend Logs",
  systemLogsDescription:
    "Browse application and parquet import logs (admin only).",
  systemLogsSource: "Source",
  systemLogsAll: "All",
  systemLogsSourceApplication: "Application",
  systemLogsSourceParquet: "Parquet import",
  systemLogsLevel: "Level",
  systemLogsLogger: "Logger contains",
  systemLogsLoggerPlaceholder: "e.g. WebsiteSearchService",
  systemLogsQuery: "Message query",
  systemLogsQueryPlaceholder: "Search message text...",
  systemLogsApply: "Apply filters",
  systemLogsRefresh: "Refresh",
  systemLogsResults: "Results",
  systemLogsEmpty: "No log entries found.",
  systemLogsLoadFailed: "Failed to load backend logs",
  systemActivityEmpty: "No activities found.",
};

